angular.module('document')
    .component('documentPrivateIco', {
        bindings: {
            private: '<',
            title: '@'
        },
        template: `
            <span ng-if="$ctrl.private" class="document-info-header" title="{{$ctrl.title}}">
                <i class="fa fa-eye-slash private-document"></i>
            </span>
        `
    })
